module.exports = __webpack_public_path__ + "static/media/READY_TO_SCAN_PACKAGES.ce1184ed.svg";